import React from 'react';

const WithRibbon = ({ children, text, display = true }) => {
  return (
    <div className="ribbon-container">
      {display && (
        <div className="ribbon">
          <span>{text}</span>
        </div>
      )}
      {children}
    </div>
  );
};

export default WithRibbon;
